export default __webpack_public_path__ + "a5ac3556fc0f41248af0bc087f0f204b.png";